import { HttpRequest } from '../../components/HttpRequest';

// Use the existing HttpRequest utility for all API calls
export const apiClient = {
  get: async (url, options = {}) => {
    const response = await HttpRequest({
      method: 'GET',
      url,
      ...options
    });
    return response;
  },

  post: async (url, data, options = {}) => {
    const response = await HttpRequest({
      method: 'POST',
      url,
      body: data,
      ...options
    });
    return response;
  },

  put: async (url, data, options = {}) => {
    const response = await HttpRequest({
      method: 'PUT',
      url,
      body: data,
      ...options
    });
    return response;
  },

  delete: async (url, options = {}) => {
    const response = await HttpRequest({
      method: 'DELETE',
      url,
      ...options
    });
    return response;
  }
};
